<template>
    <modal
        :active="active"
        :large="true"
        title="Hjælp til vareimport"
        @closed="$emit('closed', true)"
    >
        <span class="file-format">Filformat</span>
        <ul class="file-format-list ml-6 my-4">
            <li>Formatet skal være csv (brug evt. Excel og gem filen som .csv)</li>
            <li>Filen skal indeholde en række med kolonnenavne øverst. Navne på kolonnerne har ingen betydning.</li>
            <li>Alle kolonner fra feltbeskrivelsen skal med i følgende rækkefølge.</li>
        </ul>
        <table class="table is-fullwidth">
            <thead>
                <tr>
                    <th>Feltnavn</th>
                    <th>Beskrivelse</th>
                    <th>Påkrævet</th>
                    <th>Værdier</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Model</td>
                    <td>Modelnavn på varen, skal være unikt</td>
                    <td>Ja</td>
                    <td>Tekst</td>
                </tr>
                <tr>
                    <td>Varetype</td>
                    <td></td>
                    <td>Ja</td>
                    <td>with_serial, no_serial, service</td>
                </tr>
                <tr>
                    <td>Toldkode</td>
                    <td></td>
                    <td>Ja (Nej, hvis varetypen er service)</td>
                    <td>Heltal</td>
                </tr>
                <tr>
                    <td>Max. rabat</td>
                    <td>Højst tilladte rabat i procent</td>
                    <td>Nej</td>
                    <td>Heltal, 0-100</td>
                </tr>
                <tr>
                    <td>Vægt</td>
                    <td>Vægt i gram</td>
                    <td>Nej</td>
                    <td>Heltal</td>
                </tr>
                <tr>
                    <td>Min. antal</td>
                    <td>Minimum lagerbeholdning</td>
                    <td>Nej</td>
                    <td>Heltal</td>
                </tr>
                <tr>
                    <td>Beskrivelse (DA)</td>
                    <td></td>
                    <td>Nej</td>
                    <td>Tekst, max. 191 tegn</td>
                </tr>
                <tr>
                    <td>Beskrivelse (EN)</td>
                    <td></td>
                    <td>Nej</td>
                    <td>Tekst, max. 191 tegn</td>
                </tr>
                <tr>
                    <td>Note</td>
                    <td></td>
                    <td>Nej</td>
                    <td>Tekst</td>
                </tr>
                <tr>
                    <td>Landekode</td>
                    <td>2-tegns landekode</td>
                    <td>Nej</td>
                    <td>DK, DE, SE osv.</td>
                </tr>
                <tr>
                    <td>Fabrikant</td>
                    <td>Navn på fabrikanten</td>
                    <td>Nej</td>
                    <td>Tekst, skal være oprettet i systemet</td>
                </tr>
                <tr>
                    <td>Primær leverandør</td>
                    <td>Navn på leverandøren</td>
                    <td>Nej</td>
                    <td>Tekst, skal være oprettet i systemet</td>
                </tr>
                <tr>
                    <td>Sekundær leverandør</td>
                    <td>Navn på leverandøren</td>
                    <td>Nej</td>
                    <td>Tekst, skal være oprettet i systemet</td>
                </tr>
                <tr>
                    <td>Kostpris</td>
                    <td></td>
                    <td>Nej</td>
                    <td>Tal</td>
                </tr>
            </tbody>
        </table>

        <template v-slot:footer class="has-space-between">
            <button class="button is-default" @click="$emit('closed', true)">Luk import</button>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'

export default {
    components: {
        Modal,
    },
    props: {
        active: Boolean,
    },
}
</script>

<style scoped>
.file-format-list {
    list-style-type: disc;
}
.file-format {
    font-weight: bold;
    margin-left: 0.75rem;
}
</style>
